import { cn } from '@bem-react/classname';

export const cnPermanentLinkScreen = cn('PermanentLinkScreen');
